import { useEffect, useState } from "react";
import {
  AdminUpdateUserAttributes,
  SetContributorAccess,
} from "../../../../Common/lib/Admin/AdminAPI";

import { Auth } from "../../../../Common/lib/auth";

import { useHistory } from "react-router-dom";
import UserForm from "./userForm";

/**
 * Returns the edit user parent component.
 *
 * @param {*} param0
 * @returns The edit user parent component.
 */
const EditUser = ({ user, contributorAccess, setUserUpdate }) => {
  let history = useHistory();
  const [authenticatedUser, setAuthenticatedUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState({
    sub: "",
    email: "",
    fname: "",
    lname: "",
    institute: "",
    phone_number: "",
    research_field: "",
    research_geo: "",
    contributor_access: false,
    originalContributorAccess: false,
    edit_locked: "",
    dv_approval_required: "",
  });

  /**
   * Sets the specified user attributes.
   */
  const setUserAttributes = () => {
    const contribAccess = contributorAccess !== undefined ? contributorAccess : (user.ContributorAccess || false);
    setSelectedUser({
      sub: user.id || user.UserAttributes?.find((attribute) => attribute.Name === "sub")?.Value || user.Username,
      id: user.id,
      email: user.UserAttributes?.find((attribute) => attribute.Name === "email")?.Value || user.Username,
      fname: user.UserAttributes?.find((attribute) => attribute.Name === "given_name")?.Value || "",
      lname: user.UserAttributes?.find((attribute) => attribute.Name === "family_name")?.Value || "",
      institute: user.UserAttributes?.find((attribute) => attribute.Name === "institute")?.Value || "N/A",
      phone_number: user.UserAttributes?.find((attribute) => attribute.Name === "phone_number")?.Value || "",
      research_field: user.UserAttributes?.find((attribute) => attribute.Name === "research_field")?.Value || "N/A",
      research_geo: user.UserAttributes?.find((attribute) => attribute.Name === "research_geo")?.Value || "N/A",
      edit_locked: user.UserAttributes?.find((attribute) => attribute.Name === "edit_locked")?.Value || "false",
      dv_approval_required: user.UserAttributes?.find((attribute) => attribute.Name === "dv_approval_required")?.Value || "false",
      contributor_access: contribAccess,
      originalContributorAccess: contribAccess,
    });
  };

  /**
   * Gets the user object of the signed in user.
   */
  const getAuthenticatedUser = async () => {
    const authenticatedUser = await Auth.currentAuthenticatedUser();
    setAuthenticatedUser(authenticatedUser);
  };

  useEffect(() => {
    setUserAttributes();
    getAuthenticatedUser();
  }, []);

  /**
   * Handles the input changes of the specified user.
   *
   * @param {Form Event Handler} e
   */
  const userHandleChange = (e) => {
    const { name, value, checked, type } = e.target;

    if(type !== "checkbox"){
      setSelectedUser((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    else{
      setSelectedUser((prevState) => ({
        ...prevState,
        [name]: name === 'contributor_access' ? checked : checked.toString(),
      }));
    }
  };

  const userUpdateSuccessful = () => {
    history.push({
      pathname: "/admin/user-management",
      state: {
        title: "User Successfully Updated", /// Handles the title of the notification
        message: `${selectedUser.fname} ${selectedUser.lname} has been updated!`, /// Handles the subtitle of the notification
        status: true, /// Handles the color red/green
      },
    });
  };

  const userUpdateUnSuccessful = () => {
    history.push({
      pathname: "/admin/user-management",
      state: {
        title: "Unexpected Error Has Occurred",
        message: `There was an error updating ${selectedUser.fname} ${selectedUser.lname}. Please try again...`,
        status: false,
      },
    });
  };

  /**
   * OnSubmit Handler to update the specified User's attributes/contributor access.
   *
   * @param {onSubmit Handler} e
   */
  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const userId = selectedUser.id || selectedUser.sub;
      await AdminUpdateUserAttributes(userId, selectedUser);
      
      if (selectedUser.originalContributorAccess !== selectedUser.contributor_access) {
        await SetContributorAccess(userId, selectedUser.contributor_access);
      }
      
      setUserUpdate(true);
      userUpdateSuccessful();
    } catch (error) {
      console.error(error);
      userUpdateUnSuccessful();
    }
  };

  return (
    <>
      <div className="place-content-center relative sm:m-auto md:py-9 md:w-11/12 lg:w-10/12 xl:w-9/12">
        <div className="py-6 px-3 w-full md:px-5 md:py-12 bg-white md:w-full rounded-lg xl:p-12 shadow border border-gray-200">
          <header className="md:w-full">
            {user && (
              <h1 className="text-3xl py-2 font-black leading-tight text-gray-900">
                {user.UserAttributes.find((attribute) => attribute.Name === "given_name").Value}{" "}
                {user.UserAttributes.find((attribute) => attribute.Name === "family_name").Value}
              </h1>
            )}
          </header>

          <main className="mt-8 overflow-hidden md:mx-0 md:rounded-lg">
            <div className="shadow rounded-lg bg-white p-5">
              <UserForm
                history={history}
                selectedUser={selectedUser}
                onSubmit={onSubmit}
                userHandleChange={userHandleChange}
                authenticatedUser={authenticatedUser}
              />
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default EditUser;
